export class UIBaseImplementation {
    public getImplementation(config: any): any {
        throw new Error('getImplementation must be implemented');
    }
}